<template>
  <div>
    <span class="opc-cart-item__value" v-if="mx_is">
      <vloader :loading="mx_loading" :value="portionAmount" />
    </span>
    <slot v-else></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mx from './mx.vue';
import vloader from './vloader.vue';
import { PRORATED_OF } from '@/store/modules/preview';
export default {
  mixins: [mx],
  components: { vloader },
  computed: {
    ...mapGetters([
      'getSelectedPlans',
      'boughtPlans',
      'getProratedChargeAmount',
      'getIsProratedLoading',
      'getProratedChargeDetails',
    ]),
    portionAmount() {
      const planCode = this.mx_cartPlan?.plan_code;
      if (!planCode) return '';
      const updatedPlan = this.getProratedChargeDetails.find(
        (x) => x.planCode === planCode && x.of === PRORATED_OF.UPDATED,
      );
      if (!updatedPlan) return '';
      const chargeAmount = updatedPlan.chargeAmount ?? 0;
      let offsetAmount = 0;
      if (this.mx_isSingleIncreaseLicense) {
        const oldPlan = this.getProratedChargeDetails.find(
          (x) => [planCode, this.mx_cartPlan?.priceChangeMappingPlanCode].includes(x.planCode) && x.of === PRORATED_OF.CURRENT
        );
        offsetAmount = oldPlan?.chargeAmount ?? 0;
      };
      return this.$money(chargeAmount + offsetAmount);
    },
  },
};
</script>